
    import Vue from 'vue';
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";
    import {MedicalCertificateModel} from "@/api-client";

    @Component
    export default class MedicalCertificate extends Vue{
        @Prop({required: true})
        document!: MedicalCertificateModel;
    }
